import { Route, UserCheck, Lock, Eye, FileCheck2, RefreshCw } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionShell, SectionHead, FeatureCard } from "@/components/site/Primitives";

const PILLARS = [
  { icon: Route, tint: "blue", title: "Source Traceability", copy: "Recommendations link to supporting data, assumptions, evidence categories and retrieval context." },
  { icon: UserCheck, tint: "purple", title: "Human Governance", copy: "High-value actions remain subject to authorised review and approval." },
  { icon: Lock, tint: "purple", title: "Customer-Specific Segregation", copy: "Customer decision memory is designed to remain secure, permissioned and separated between customer environments." },
  { icon: Eye, tint: "blue", title: "Explainability", copy: "Recommendations include rationale, confidence, assumptions, limitations and change triggers." },
  { icon: FileCheck2, tint: "green", title: "Auditability", copy: "Decision versions, approval status, evidence and outcomes can be documented and reviewed." },
  { icon: RefreshCw, tint: "purple", title: "Governed Learning", copy: "Validated results can improve customer-specific recommendations without uncontrolled or automatic cross-customer learning." },
];

export function Governance() {
  return (
    <SectionShell id="governance" tone="white">
      <div className="max-w-3xl">
        <SectionHead
          label="Trust, Governance and Control"
          labelColor="purple"
          title="Explainable intelligence. Permissioned context. Human-approved action."
          intro="Enterprise trust comes first—through traceable evidence, human governance, segregated customer context and explainability by design."
        />
      </div>

      <div className="mt-14 grid grid-cols-1 gap-x-5 gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 3) * 0.07}>
            <FeatureCard icon={p.icon} tint={p.tint} title={p.title}>
              {p.copy}
            </FeatureCard>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <div className="mt-12 flex items-start gap-3 rounded-xl border border-natsu-purple/15 bg-natsu-purple/[0.04] p-5">
          <span className="mt-0.5 h-2 w-2 flex-shrink-0 rounded-full bg-natsu-purple" />
          <p className="max-w-[64ch] text-[15px] leading-relaxed text-natsu-navy/80">
            Designed with enterprise governance, traceability and controlled
            deployment in mind.
          </p>
        </div>
      </Reveal>
    </SectionShell>
  );
}
